var _defs, _style, _use, _use2, _use3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaynowCoverLetter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130 117",
    width: 130,
    height: 117,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "New Project") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 122,
    height: 77,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHoAAABNCAMAAABe+IDDAAAAAXNSR0IB2cksfwAAADxQTFRFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA0C8mMAAAABR0Uk5TABBQgH/v/48g32BAML+fkKCvcG9F+K6JAAACI0lEQVR4nL3a2XqCMBAFYBZRloi1vv+7Vqx85swgZDmTcwk1Y/g1W62q5NRN27ZNnd5AcuFTd17SXfrCld+FlwxjycLTcPYzNKUKu+tZZi7y1OuLKrykALmHjLEmF8iiuCH5BnIZco18cz9FyBXydXpe7aUAn1whD9P7zqjuUMkVctd6Y3drR76BjJNGb0W+jYwxIf+OjKGT7yNDair5ITKGSB6CjHEc8lBkDIE8AhmTSx6JjMkij0fGJJOnIWOSyJORMfHkWciYSPJcZEwEuUbOnXkDyUnImBByjTxzNnKH5FxkzC65vsldUWvyteON6DIDGaPIO/e63ovKJGSMJO9e/b5bIWOE6n15P4bIGCSvYRXNR8YA+a//vE2QMR75XFXrINaVORJpvNKf93Gy77U3aM5gbX4W9PC+x0/rCT7hzrAwzozLFxtnLLOzoF7UWa45MZqZkMuZ8X80q0a8akH+kDPjOnQ1ambhkuvlz6f93vBgQCKrQVMvJkjkIcsf/VQY5Ap5e2bUi4lc8vA1Lpn8CFn8NY88fo3LIg9ExjDIUzcy2eRxyOK1OeS5G5l08iRkTBo5Z7eaQJ6DLFrS5HvFubvVGHICMkaTbzfIP5IIJOchi3aPyM2OJKojcjoy5ju5BTLmC7kVsiiuyZ0hMmb3n6l8ZIwiN0XGaHJTZFFckZsiYzbILZExgrzcLzQqJC+ALIqv5GV+FyKKj7f5Nqb3+A8OA0CTHD07LQAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    width: 131,
    height: 45,
    id: "img2",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIMAAAAtCAMAAAC6VSjKAAAAAXNSR0IB2cksfwAAADlQTFRFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAvHZQPQAAABN0Uk5TABAgML//33B/72BQr0Cfz4CgkAib93EAAAFYSURBVHiczdTRcoIwEIVhExMULEp9/4dtGrDx7FohZHfb/0rBmRzlGw+Hf5Lzf3Swd8uLY4ixO9kPcOc+xpC/vk+vUt1gPOHS5XP77xEhLn1YPpHx59iQfpFYulqtcNdyaJ8exdMGIxYZQildgfcWLBYIj27p0iliyiwKhKX8pSdyUZPFM4S5ab7h6TQtFgRCfPw95IaOrtBgcWGnjHB/ovfFWTAIPfu1/acqCw7h7l58TJHFWwiYFos1CJgGiw0QMHEWGyGQFZIsKiBgcizqIGAyLKohYAIsdkEgK9pY7IaAtbBogYDtZdEIAdvFQgACWVHLQggCVsdCDgK2nYUoBGwjC3EIZMU6CxUI2BoLLQjYOxaKELBfWShDICtesTCAgHEW7BGpQMDYmTYQMM7CBgJZQVkYQcAYCyMIGGNhAwEjLMwgkBWFhSkEbJhXBGsImBvHY+tT+AIVwh43hYgwsgAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    width: 131,
    height: 45,
    id: "img3",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIMAAAAtCAMAAAC6VSjKAAAAAXNSR0IB2cksfwAAADlQTFRFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAvHZQPQAAABN0Uk5TABAgML//33B/72BQr0Cfz4CgkAib93EAAAFYSURBVHiczdTRcoIwEIVhExMULEp9/4dtGrDx7FohZHfb/0rBmRzlGw+Hf5Lzf3Swd8uLY4ixO9kPcOc+xpC/vk+vUt1gPOHS5XP77xEhLn1YPpHx59iQfpFYulqtcNdyaJ8exdMGIxYZQildgfcWLBYIj27p0iliyiwKhKX8pSdyUZPFM4S5ab7h6TQtFgRCfPw95IaOrtBgcWGnjHB/ovfFWTAIPfu1/acqCw7h7l58TJHFWwiYFos1CJgGiw0QMHEWGyGQFZIsKiBgcizqIGAyLKohYAIsdkEgK9pY7IaAtbBogYDtZdEIAdvFQgACWVHLQggCVsdCDgK2nYUoBGwjC3EIZMU6CxUI2BoLLQjYOxaKELBfWShDICtesTCAgHEW7BGpQMDYmTYQMM7CBgJZQVkYQcAYCyMIGGNhAwEjLMwgkBWFhSkEbJhXBGsImBvHY+tT+AIVwh43hYgwsgAAAABJRU5ErkJggg=="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Background",
    href: "#img1",
    x: 4,
    y: 0
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    id: "Layer 1",
    href: "#img2",
    x: 0,
    y: 52
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    id: "Layer 2",
    href: "#img3",
    x: 0,
    y: 72
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaynowCoverLetter);
export default __webpack_public_path__ + "static/media/paynowCoverLetter.c7acd7054f401357b349a1e6186a319c.svg";
export { ForwardRef as ReactComponent };